import { FC } from 'react';
import { AText } from '../../../../../../../AText';
import { Box } from '../../../../../../../Box';
import { GroupHeaderProps } from '../../../../../../types';

import styles from './index.module.css';

export const GroupHeader: FC<GroupHeaderProps> = ({
  title,
  iconElement,
  size
}) => (
  <Box className={styles[size]} align="center" padding="s" gap="s">
    {iconElement}
    {title && (
      <AText
        breed="BU"
        color="input_dropdown_txt_1"
        transform="uppercase"
        size={size}
      >
        {title}
      </AText>
    )}
  </Box>
);
